/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Menu_LabelInputs */



/**
* | output |
* | --- |
* | "Show menu" |
*
* @param {Speakers_Menu_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_menu_label = /** @type {((inputs?: Speakers_Menu_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Menu_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "de") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "es") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Show menu")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Show menu")
	return /** @type {LocalizedString} */ ("Show menu")
});